import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // const isAuthenticated = cksrv.cookieCheck('UID') 
  const isAuthenticated = localStorage.getItem('access_token');
  if (isAuthenticated) {
    return true;
  } else {
    router.navigate(['/'], { replaceUrl: true });
    return false;
  }
};
